import React, { useState } from 'react';
import { Colors } from 'library';
import { PillButton } from 'library/ui';
import { AppBar, Grid, Toolbar } from '@mui/material';
import WhiteHeader from './WhiteHeader';
import CenterMenu from './CenterMenu';
import WorkerMenu from './WorkerMenu';
import ResourceMenu from './ResourceMenu';
import ServicesMenu from './ServicesMenu';

export default function DefaultBar() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isWorkerMenuOpen, setIsWorkerMenuOpen] = useState(false);
    const [isResourcesMenuOpen, setIsResourcesMenuOpen] = useState(false);
    const [isServicesMenuOpen, setIsServicesMenuOpen] = useState(false);
    const menuRef = React.useRef<HTMLDivElement>(null);
    const workerMenuRef = React.useRef<HTMLDivElement>(null);
    const resourceMenuRef = React.useRef<HTMLDivElement>(null);
    const servicesMenuRef = React.useRef<HTMLDivElement>(null);

    function handleMenuClose() {
        setIsMenuOpen(false);
    }

    function handleWorkerMenuClose() {
        setIsWorkerMenuOpen(false);
    }

    function handleResourceMenuClose() {
        setIsResourcesMenuOpen(false);
    }

    function handleServicesMenuClose() {
        setIsServicesMenuOpen(false);
    }

    return (
        <Grid>
            <AppBar position="static" sx={styles.appbar}>
                <Toolbar sx={styles.toolbar}>
                    <WhiteHeader />
                    <PillButton id="center-login-link" to="/login">
                        Center Login
                    </PillButton>
                </Toolbar>
            </AppBar>
            <CenterMenu handleMenuClose={handleMenuClose} isMenuOpen={isMenuOpen} anchorRef={menuRef} />
            <WorkerMenu
                handleMenuClose={handleWorkerMenuClose}
                isMenuOpen={isWorkerMenuOpen}
                anchorRef={workerMenuRef}
            />
            <ResourceMenu
                handleMenuClose={handleResourceMenuClose}
                isMenuOpen={isResourcesMenuOpen}
                anchorRef={resourceMenuRef}
            />
            <ServicesMenu
                handleMenuClose={handleServicesMenuClose}
                isMenuOpen={isServicesMenuOpen}
                anchorRef={servicesMenuRef}
            />
        </Grid>
    );
}

export const styles = {
    toolbar: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    appbar: { flexGrow: 1, backgroundColor: Colors.white },
    menuText: { cursor: 'pointer', fontSize: 16 },
    widthUnset: { width: 'unset' },
};
